(function ($, window) {
    class Grid {
        items = [];
        content = '.card-more';
        expanded = '.cardExpanded';
        trigger = '.js-expand';
        grid = '.js-grid';
        wrapper = '<div class="column one-whole"></div>';
        maxColumns = 3;

        responsive = [
            [800, 2],
            [480, 1],
        ];

        state = {
            total: 0,
            columns: 3,
            rows: 0,
        };

        constructor(selector) {
            if (typeof selector === 'string') {
                this.el = $(selector);
            } else {
                this.el = $(selector);
            }

            this.items = this.el.find('.card');
            this.addEventListeners();
            this.resize();
            this.calc();
        }

        addEventListeners() {
            let _this = this;
            this.el.find('.js-grid').on('click', function (e) {
                e.preventDefault();
                _this.expand($(this));
            });

            // on resize set grid item sizes and grid state
            $(window).on('resize', () => {
                this.resize();
                this.calc();
            });

            // when images are loaded, set the grid items sizes
            $('.grid-row').imagesLoaded(() => {
                this.resize();
            });
        }

        resize() {
            // set the default smallest height
            var height = 0;

            // reset team heights to auto
            this.items.height('auto');

            // foreach team member
            this.items.each(function () {
                if ($(this).outerHeight() > height) {
                    height = $(this).outerHeight();
                }
            });

            this.items.outerHeight(height);
        }

        calc() {
            // total number of team items
            this.state.total = this.items.length;

            // default is 4 columns at max width
            this.state.columns = this.maxColumns;

            // determine correct row size on responsive layouts
            for (var i in this.responsive) {
                size = this.responsive[i][0];
                cols = this.responsive[i][1];

                if ($(window).width() <= size) {
                    this.state.columns = cols;
                }
            }

            // calculate total rows in the grid
            this.state.rows = Math.ceil(this.state.total / this.state.columns);
        }

        expand($el, callback) {
            // when working with callbacks
            // this will refer to the item the callbacks in
            // not this object (Team)
            let _this = this;

            // if an expanded view is already open
            if (this.el.find(this.expanded).length) {
                // if this is the item that is expanded
                if ($el.hasClass('active')) {
                    // close it
                    this.close($el);
                    // else close the other expanded view
                    // before opening this one
                } else {
                    // grab the open element
                    var $open = this.el.find(this.grid + '.active');
                    // close it
                    this.close($open, function () {
                        // once closed open new element
                        _this.open($el);
                    });
                }
            } else {
                this.open($el);
            }
        }

        open($el, callback) {
            $el.addClass('active');

            // index of the item
            var index = $el.index();

            // the row the team member is on
            var row = Math.floor(index / this.state.columns) + 1;

            // the position to insert new html
            var position = this.state.columns * row - 1;

            // if the position is greater than the total items
            // make the position the last element
            if (position > this.state.total - 1) {
                position = this.state.total - 1;
            }

            // the content to add
            var $content = $el.find(this.content).html();

            // create html to add
            var $html = $(this.wrapper)
                .addClass(this.expanded.substring(1))
                .html($content);

            // add and open the exapnded view
            this.el.find(this.grid + ':eq(' + position + ')').after($html);

            $html.slideDown(300, function () {
                if (callback) {
                    callback();
                }
            });
        }

        close($el, callback) {
            // remove the active class
            $el.removeClass('active');

            // slide up the expanded view
            this.el.find(this.expanded).slideUp(300, function () {
                // remove the expanded view
                $(this).remove();

                if (callback) {
                    callback();
                }
            });
        }
    }

    document.querySelectorAll('.grid-row').forEach((grid) => {
        new Grid(grid);
    });
})(jQuery, window);
